module.exports = __webpack_public_path__ + "static/first_choice_interested-1442d346e59a4f3bba77c42f55980a3d.jpg";